import {createFileRoute, redirect} from '@tanstack/react-router';

import {defaultLandingPageRoute} from '~utils/routeUtil';

export const Route = createFileRoute('/tasks/session')({
  beforeLoad: async () => {
    // Teach sessions are retired and no longer reachable from the UI
    throw redirect({
      to: defaultLandingPageRoute as any,
    });
  },
});
